import { useEffect } from "react";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { useSiteSettings } from "@/lib/useSiteSettings";

export default function OpeningBanner() {
    const { settings } = useSiteSettings();
    const visible = !!(settings.opening_banner_enabled && settings.opening_banner_text);

    // Push the fixed navbar down while the banner is visible
    useEffect(() => {
        document.documentElement.style.setProperty(
            "--banner-height",
            visible ? "40px" : "0px",
        );
        return () => {
            document.documentElement.style.setProperty("--banner-height", "0px");
        };
    }, [visible]);

    if (!visible) return null;

    return (
        <motion.div
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            data-testid="opening-banner"
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                zIndex: 100,
                height: 40,
                background:
                    "linear-gradient(90deg, var(--terra-light) 0%, var(--terra) 60%, var(--terra-deep) 100%)",
                color: "#ffffff",
                textAlign: "center",
                padding: "0 24px",
                fontFamily: "var(--font-body)",
                fontSize: 13,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 12px -6px rgba(107, 85, 72, 0.35)",
            }}
        >
            <span style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
                <Sparkles size={13} />
                {settings.opening_banner_text}
                <Sparkles size={13} />
            </span>
        </motion.div>
    );
}
